{
  "tab": "الفوترة",
  "header": {
    "invoiceMilestone_zero": "فوترة الدفعات",
    "invoiceMilestone_one": "فوترة دفعة",
    "invoiceMilestone_two": "فوترة دفعتين",
    "invoiceMilestone_few": "فوترة {{count}} دفعات",
    "invoiceMilestone_many": "فوترة {{count}} دفعة",
    "invoiceMilestone_other": "فوترة {{count}} دفعة",
    "invoiceReady_zero": "فوترة البنود الجاهزة",
    "invoiceReady_one": "فوترة بند جاهز",
    "invoiceReady_two": "فوترة بندين جاهزين",
    "invoiceReady_few": "فوترة {{count}} بنود جاهزة",
    "invoiceReady_many": "فوترة {{count}} بندًا جاهزًا",
    "invoiceReady_other": "فوترة {{count}} بند جاهز",
    "invoiceUnbilled": "فوترة التكاليف غير المفوترة"
  },
  "status": {
    "PLANNED": "مخطط",
    "READY": "جاهز",
    "INVOICED": "مفوتر",
    "CANCELLED": "ملغى"
  },
  "payment": {
    "UNPAID": "غير مدفوعة",
    "PARTIAL": "مدفوعة جزئيًا",
    "PAID": "مدفوعة",
    "OVERDUE": "متأخرة"
  },
  "basis": {
    "FIXED": "مبلغ ثابت",
    "PERCENT": "نسبة مئوية"
  },
  "trigger": {
    "MANUAL": "عند تعليمه جاهزًا",
    "DATE": "في تاريخ محدد",
    "MILESTONE": "عند إنجاز معلم"
  },
  "grouping": {
    "ROLE": "حسب الدور",
    "PERSON": "حسب الشخص",
    "ENTRY": "سطر لكل سجل وقت"
  },
  "salesOff": {
    "title": "الفوترة متوقفة حتى تفعيل المبيعات",
    "body": "المبيعات معطلة لشركتك، فلا يمكن إصدار فاتورة أو إبطالها من هنا. تبقى البنود الجاهزة ظاهرة وتستمر الأرقام في الاحتساب، ويفعّل المسؤول المبيعات من الإعدادات › الوحدات."
  },
  "strip": {
    "label": "أرقام الفوترة",
    "contract": "قيمة العقد",
    "noContract": "لا توجد قيمة عقد",
    "contractSub": "قبل الضريبة",
    "billed": "المفوتر",
    "billedSub": "قبل الضريبة، بعد خصم الإشعارات الدائنة",
    "collected": "المحصّل",
    "collectedSub": "{{percent}}% من {{invoiced}} المفوترة شاملة الضريبة",
    "nothingInvoiced": "لم تُصدر فواتير بعد",
    "outstanding": "المستحق",
    "outstandingSub": "مفتوح في المبيعات، شامل الضريبة",
    "ready": "جاهز للفوترة",
    "readySub": "بنود الخطة الجاهزة، قبل الضريبة",
    "readyNone": "لا يوجد بند جاهز",
    "unbilled": "الوقت والمواد غير المفوترة",
    "unbilledSub": "لم تُفوتر بعد، قبل الضريبة",
    "opening": "تشمل أرقامًا من قبل التشغيل (حتى {{date}}): مفوتر {{billed}}، ومحصّل {{collected}}."
  },
  "plan": {
    "title": "خطة الفوترة",
    "covers": "تغطي الخطة {{percent}}% من قيمة العقد: {{total}} من {{contract}}.",
    "overContract": "أكثر من قيمة العقد",
    "noContract": "لا توجد قيمة عقد: لا يمكن استخدام البنود بالنسبة المئوية.",
    "split": {
      "INVOICED": "مفوتر {{amount}}",
      "READY": "جاهز {{amount}}",
      "PLANNED": "مخطط {{amount}}"
    },
    "percentOf": "{{percent}}% من العقد",
    "total": "إجمالي الخطة",
    "select": "تحديد {{item}}",
    "selectAll": "تحديد كل البنود الجاهزة",
    "columns": {
      "select": "تحديد",
      "item": "البند",
      "milestone": "المعلم",
      "basis": "الأساس",
      "amount": "المبلغ",
      "date": "التاريخ المخطط",
      "status": "الحالة",
      "actions": "الإجراءات"
    },
    "when": {
      "DATE": "مستحق الفوترة في {{date}}",
      "MILESTONE": "عند إنجاز «{{milestone}}»",
      "MANUAL": "عند تعليمه جاهزًا",
      "MANUAL_READY": "عُلّم جاهزًا في {{date}}",
      "cancelled": "ملغى: {{reason}}"
    },
    "actions": {
      "label": "إجراءات {{item}}",
      "add": "إضافة بند",
      "addFirst": "إضافة أول بند",
      "invoice": "إنشاء فاتورة",
      "invoiceShort": "فوترة",
      "invoiceNamed": "فوترة {{item}}",
      "edit": "تعديل",
      "ready": "تعليمه جاهزًا",
      "unready": "إلغاء الجاهزية",
      "up": "نقل لأعلى",
      "down": "نقل لأسفل",
      "cancel": "إلغاء البند…",
      "delete": "حذف"
    },
    "bulk": {
      "label": "بنود الفوترة المحددة",
      "summary_zero": "لا بنود جاهزة · {{total}}",
      "summary_one": "بند جاهز واحد · {{total}}",
      "summary_two": "بندان جاهزان · {{total}}",
      "summary_few": "{{count}} بنود جاهزة · {{total}}",
      "summary_many": "{{count}} بندًا جاهزًا · {{total}}",
      "summary_other": "{{count}} بند جاهز · {{total}}",
      "clear": "إلغاء التحديد",
      "invoice_zero": "إنشاء فاتورة",
      "invoice_one": "إنشاء فاتورة",
      "invoice_two": "إنشاء فاتورة واحدة للبندين",
      "invoice_few": "إنشاء فاتورة واحدة لـ {{count}} بنود",
      "invoice_many": "إنشاء فاتورة واحدة لـ {{count}} بندًا",
      "invoice_other": "إنشاء فاتورة واحدة لـ {{count}} بند"
    },
    "empty": {
      "canAdd": "لا توجد خطة فوترة بعد. أضف الدفعات التي يسددها العميل: مبلغ أو حصة من العقد، تُفوتر في تاريخ أو عند معلم أو عند تعليمها جاهزة.",
      "readOnly": "لا توجد خطة فوترة بعد."
    },
    "cancel": {
      "title": "إلغاء «{{item}}»؟",
      "body": "البند الملغى لا يُفوتر أبدًا ويخرج من إجماليات الخطة، ويبقى ظاهرًا مع سببك.",
      "reason": "لماذا أُلغي؟",
      "confirm": "إلغاء البند"
    },
    "delete": {
      "title": "حذف هذا البند؟",
      "body": "لم يُفوتر «{{item}}» قط، لذا يُحذف من الخطة.",
      "confirm": "حذف البند"
    },
    "toast": {
      "ready": "عُلّم جاهزًا للفوترة",
      "unready": "أُلغيت جاهزيته",
      "cancelled": "أُلغي البند",
      "deleted": "حُذف البند"
    }
  },
  "item": {
    "newTitle": "إضافة بند فوترة",
    "editTitle": "تعديل بند الفوترة",
    "description": "دفعة واحدة من خطة الفوترة، تصبح سطرًا واحدًا في الفاتورة.",
    "fields": {
      "description": "نص سطر الفاتورة",
      "basis": "المبلغ",
      "amount": "المبلغ (دون الضريبة)",
      "percent": "النسبة من العقد",
      "trigger": "الجاهزية للفوترة",
      "billDate": "تاريخ الفوترة",
      "expectedDate": "التاريخ المتوقع",
      "tax": "ضريبة القيمة المضافة",
      "milestone": "المعلم"
    },
    "basisBody": {
      "FIXED": "مبلغ محدد دون الضريبة.",
      "PERCENT": "حصة من قيمة العقد تُحتسب عند الفوترة.",
      "PERCENT_OFF": "تتطلب قيمة عقد للمشروع."
    },
    "hints": {
      "description": "يقرأ العميل هذا النص في الفاتورة.",
      "amount": "دون الضريبة: تُضاف الضريبة في الفاتورة.",
      "percent": "حتى 100 بخانتين عشريتين.",
      "percentOf": "يفوتر اليوم {{amount}} من عقد قيمته {{contract}}.",
      "billDate": "يصبح جاهزًا للفوترة في هذا التاريخ.",
      "milestone": "يصبح جاهزًا عند إنجاز هذا المعلم.",
      "milestoneOptional": "اختياري: المعلم الذي تخصه هذه الدفعة."
    },
    "placeholders": {
      "description": "مثال: دفعة التعبئة المقدمة 20%",
      "milestone": "اختر معلمًا",
      "searchMilestone": "ابحث في المعالم…"
    },
    "noMilestones": "لا يوجد معلم مطابق في الخطة.",
    "noMilestone": "دون معلم",
    "projectRate": "نسبة المشروع",
    "projectRateNamed": "نسبة المشروع ({{rate}})",
    "errors": {
      "description": "أدخل نص سطر الفاتورة.",
      "amount": "أدخل مبلغًا أكبر من صفر.",
      "percent": "أدخل نسبة أكبر من 0 وحتى 100.",
      "percentNoContract": "حدد قيمة عقد المشروع أولًا: النسبة من العقد.",
      "plannedDate": "اختر تاريخ الفوترة.",
      "milestone": "اختر المعلم الذي يجعله جاهزًا.",
      "field": "تحقق من هذه القيمة."
    },
    "add": "إضافة البند",
    "save": "حفظ البند",
    "added": "أُضيف بند الفوترة",
    "saved": "حُفظ بند الفوترة"
  },
  "sheet": {
    "title": "إنشاء فاتورة",
    "description": "راجع الفاتورة التي سيصدرها {{code}} قبل ترحيلها.",
    "invoiceDate": "تاريخ الفاتورة",
    "invoiceDateHint": "يتبع تاريخ الاستحقاق شروط الدفع للعميل.",
    "consequence": "سيُصدر هذا فاتورة مرحّلة بمبلغ {{total}} (الضريبة {{tax}}) إلى {{customer}}، تستحق في {{due}}.",
    "slip": "معاينة الفاتورة",
    "billTo": "الفاتورة إلى",
    "meta": "بتاريخ {{date}} · تستحق {{due}}",
    "reference": "المرجع",
    "previewStamp": "معاينة",
    "linesCaption_zero": "لا بنود أو سطور مفوترة",
    "linesCaption_one": "بند أو سطر واحد مفوتر",
    "linesCaption_two": "بندان أو سطران مفوتران",
    "linesCaption_few": "{{count}} بنود أو سطور مفوترة",
    "linesCaption_many": "{{count}} بندًا أو سطرًا مفوترًا",
    "linesCaption_other": "{{count}} بند أو سطر مفوتر",
    "columns": {
      "description": "السطر",
      "net": "المبلغ"
    },
    "noTax": "دون ضريبة",
    "subtotal": "المجموع الفرعي",
    "tax": "الضريبة",
    "total": "الإجمالي",
    "posts": "تُرحّل الفاتورة إلى الدفاتر فورًا.",
    "confirm": "إصدار الفاتورة",
    "retry": "إعادة المحاولة",
    "failed": "لم تُصدر الفاتورة",
    "previewFailed": "تعذر إعداد المعاينة",
    "toast": "صدرت الفاتورة {{number}}",
    "toastRepeat": "سبق إصدار الفاتورة {{number}}",
    "issuedTitle": "صدرت الفاتورة {{number}}",
    "issuedBody": "رُحّلت الفاتورة {{number}} بمبلغ {{total}}، وتظهر البنود التي فوترتها مفوترة.",
    "repeatBody": "سبق لهذا الطلب أن أصدر الفاتورة {{number}}، ولم يُصدر شيء مرتين.",
    "open": "فتح {{number}}",
    "done": "تم"
  },
  "unbilled": {
    "title": "الوقت والمواد غير المفوترة",
    "hint": "تكاليف قابلة للفوترة مرتبطة بهذا المشروع ولم تُفوتر بعد.",
    "markup": "تُعاد فوترة التكاليف بالتكلفة مضافًا إليها {{percent}}%، ما لم يُحدَّد مبلغ يدويًا.",
    "showNotBillable": "إظهار السطور المشطوبة وغير القابلة للفوترة",
    "notBillable": "غير قابل للفوترة: فئة تكلفته لا تُعاد فوترتها",
    "groupBy": "سطور الفاتورة",
    "empty": "لا شيء متبقٍ للفوترة. تظهر التكاليف هنا عند ربط المشتريات أو المصروفات أو صرف المخزون بهذا المشروع.",
    "noCategory": "دون فئة",
    "noNumber": "مسودة",
    "time": "الوقت",
    "lines_zero": "لا سطور",
    "lines_one": "سطر واحد",
    "lines_two": "سطران",
    "lines_few": "{{count}} سطور",
    "lines_many": "{{count}} سطرًا",
    "lines_other": "{{count}} سطر",
    "costShort": "التكلفة",
    "total": "الإجمالي القابل للفوترة",
    "select": "تحديد {{line}}",
    "selectAll": "تحديد كل السطور القابلة للفوترة",
    "selectGroup": "تحديد كل سطور {{group}}",
    "writtenOff": "مشطوب",
    "writtenUp": "مرفوع",
    "adjusted": "مبلغ محدد يدويًا",
    "reason": "السبب",
    "columns": {
      "date": "التاريخ",
      "source": "المستند",
      "node": "جزء الخطة",
      "cost": "التكلفة",
      "bills": "يُفوتر"
    },
    "actions": {
      "label": "إجراءات {{line}}",
      "amount": "تغيير المبلغ…",
      "writeOff": "شطب…",
      "reset": "الفوترة بالتكلفة مع الهامش",
      "putBack": "إعادته للفوترة",
      "bill": "فوترة هذا السطر…",
      "setAmount": "تحديد مبلغ…",
      "resetTime": "الفوترة بالسعر"
    },
    "bulk": {
      "label": "السطور المحددة",
      "summary_zero": "لا سطور · {{total}}",
      "summary_one": "سطر واحد · {{total}}",
      "summary_two": "سطران · {{total}}",
      "summary_few": "{{count}} سطور · {{total}}",
      "summary_many": "{{count}} سطرًا · {{total}}",
      "summary_other": "{{count}} سطر · {{total}}",
      "invoice": "فوترة المحدد"
    },
    "off": {
      "title": "شطب {{line}}؟",
      "body": "لن يُفوتر ({{amount}}). يبقى ظاهرًا ضمن السطور المشطوبة ويمكن فوترته لاحقًا.",
      "confirm": "شطب"
    },
    "amount": {
      "title": "تغيير مبلغ {{line}}",
      "body": "التكلفة {{cost}}، وبهامش {{markup}}% يُفوتر {{amount}}. المبلغ الأعلى يرفعه والأقل يشطب جزءًا منه.",
      "confirm": "حفظ المبلغ",
      "field": "فوترة هذا المبلغ (دون الضريبة)",
      "hint": "اتركه فارغًا للفوترة بالتكلفة مع الهامش.",
      "hintTime": "اتركه فارغًا لفوترة الساعات بالسعر.",
      "hintNoRate": "لا يوجد سعر فوترة: المبلغ الذي تدخله هو ما يُفوتر."
    },
    "bill": {
      "title": "فوترة {{line}}؟",
      "body": "فئة تكلفته لا تُعاد فوترتها. إن فُوتر يُفوتر {{amount}}: التكلفة {{cost}} مضافًا إليها {{markup}}%.",
      "confirm": "فوترته"
    },
    "toast": {
      "off": "شُطب السطر",
      "amount": "حُفظ المبلغ",
      "bill": "أُضيف السطر إلى ما يُفوتر",
      "cleared": "عاد السطر إلى التكلفة مع الهامش",
      "clearedTime": "عاد السطر إلى سعره"
    },
    "timeHint": "ويُفوتر الوقت المعتمد بسعر الفوترة الخاص به.",
    "noRate": "بلا سعر فوترة",
    "noRateHint": "حدد سعر فوترة للعضو أو لدور التسعير الخاص به، أو عدّل المبلغ يدويًا.",
    "noRateWaiting_zero": "لا أسطر وقت بانتظار سعر فوترة.",
    "noRateWaiting_one": "سطر وقت واحد بانتظار سعر فوترة ولا يمكن فوترته بعد.",
    "noRateWaiting_two": "سطرا وقت بانتظار سعر فوترة ولا يمكن فوترتهما بعد.",
    "noRateWaiting_few": "{{count}} أسطر وقت بانتظار سعر فوترة ولا يمكن فوترتها بعد.",
    "noRateWaiting_many": "{{count}} سطرًا من الوقت بانتظار سعر فوترة ولا يمكن فوترتها بعد.",
    "noRateWaiting_other": "{{count}} سطر وقت بانتظار سعر فوترة ولا يمكن فوترتها بعد.",
    "timeLine": {
      "hours": "{{hours}} س",
      "rate": "{{hours}} س × {{rate}}",
      "noRole": "بلا دور تسعير",
      "notBillable": "غير قابل للفوترة: سُجّل على أنه غير قابل للفوترة",
      "billBody": "سُجّل على أنه غير قابل للفوترة. وإن فُوتر رغم ذلك فيُفوتر وقته ({{hours}}) بالسعر.",
      "amountBody": "{{hours}} بسعر {{rate}} للساعة تُفوتر {{amount}}. المبلغ الأعلى يرفعه والأقل يشطب جزءًا منه.",
      "amountBodyNoRate": "{{hours}} بلا سعر فوترة: أدخل المبلغ المراد فوترته."
    }
  },
  "documents": {
    "title": "الفواتير والإشعارات الدائنة",
    "hint": "كل مستندات هذا المشروع: الصادرة من هذا التبويب أو المرتبطة بالمشروع في المبيعات.",
    "empty": "لا توجد فواتير بعد. تظهر هنا فواتير المستخلصات والدفعة المقدمة والإفراج عن المحتجزات، والفواتير الصادرة من الخطة أو عن التكاليف، ومستندات المبيعات المرتبطة بهذا المشروع.",
    "columns": {
      "number": "المستند",
      "date": "التاريخ",
      "status": "الحالة",
      "total": "الإجمالي",
      "balance": "الرصيد"
    },
    "type": {
      "INVOICE": "فاتورة",
      "DEBIT_NOTE": "إشعار مدين",
      "CREDIT_NOTE": "إشعار دائن"
    },
    "kind": {
      "MILESTONE": "خطة الفوترة",
      "TM": "تكاليف معاد فوترتها",
      "CLAIM": "مستخلص",
      "ADVANCE": "دفعة مقدمة",
      "RETENTION_RELEASE": "إفراج عن محتجزات",
      "ADVANCE_REDUCTION": "استرداد دفعة مقدمة"
    },
    "tagged": "مرتبط في المبيعات",
    "draft": "مسودة",
    "balance": "الرصيد",
    "void": "إبطال من المشروع",
    "voidNamed": "إبطال من المشروع: {{number}}",
    "voidTitle": "إبطال {{number}} من المشروع؟",
    "voidWhat": "يُبطل {{number}} ({{total}}، {{customer}}) في المبيعات بتاريخها.",
    "voidBackItems": "تعود البنود التي فوترتها جاهزة لتُفوتر من جديد.",
    "voidBackNamed_zero": "{{items}} يعود جاهزًا ليُفوتر من جديد.",
    "voidBackNamed_one": "{{items}} يعود جاهزًا ليُفوتر من جديد.",
    "voidBackNamed_two": "{{items}} يعودان جاهزين ليُفوترا من جديد.",
    "voidBackNamed_few": "{{items}} تعود جاهزة لتُفوتر من جديد.",
    "voidBackNamed_many": "{{items}} تعود جاهزة لتُفوتر من جديد.",
    "voidBackNamed_other": "{{items}} تعود جاهزة لتُفوتر من جديد.",
    "voidBackTm": "تعود تكاليفها المعاد فوترتها غير مفوترة.",
    "voidReasonLabel": "لماذا تُبطَل؟",
    "voidConfirm": "إبطال الفاتورة",
    "voided": "أُبطل {{number}}",
    "voidReason": "مُبطَل: {{reason}}",
    "voidBlocked": {
      "HAS_PAYMENTS": "سندات قبض مطبقة عليها: فكّها في المبيعات أولًا.",
      "HAS_CREDIT_NOTES": "صدرت إشعارات دائنة مقابلها: أبطِلها أولًا.",
      "PERIOD_LOCKED": "تاريخها في فترة مقفلة: لا يمكن إبطالها."
    }
  },
  "fromQuotation": {
    "quotation": "عرض سعر معتمد",
    "quotationHint": "يأخذ المشروع عميله وقيمته وبنوده.",
    "choose": "اختر عرض سعر",
    "search": "ابحث بالرقم أو العميل…",
    "none": "لا يوجد عرض سعر معتمد مطابق.",
    "quotationsError": "تعذر تحميل عروض الأسعار.",
    "expiredMark": "منتهي",
    "customer": "العميل",
    "contractValue": "قيمة العقد",
    "exVat": "المجموع الفرعي دون الضريبة",
    "exVatQuotedInc": "المجموع الفرعي دون الضريبة (عُرض شاملًا الضريبة)",
    "validUntil": "صالح حتى",
    "expiredTitle": "انتهت صلاحية عرض السعر هذا",
    "expiredBody": "كان صالحًا حتى {{date}}. تأكد أن العميل ما زال يقبله قبل بدء المشروع.",
    "confirmExpired": "قبله العميل: ابدأ المشروع على أي حال",
    "typeHint": "وظائفه وقالب خطته، ويمكن تغيير طريقة الفوترة أدناه.",
    "billingMethod": "الفوترة",
    "nameHint": "إن تُرك فارغًا: العميل ورقم عرض السعر.",
    "endFromTemplate": "من قالب خطة النوع؛ غيّره إن استغرق العمل وقتًا أطول.",
    "consequence": "بدء مشروع يعني أنه لم يعد ممكنًا تحويل عرض السعر هذا إلى فاتورة: تُفوتره من المشروع.",
    "lines": "بنود عرض السعر",
    "linesItems": "البنود التي تصبح بنود فوترة",
    "linesHint": {
      "FIXED_PRICE": "كل بند محدد يصبح بند فوترة بصافي مبلغه، جاهزًا للفوترة عند تعليمه جاهزًا. ادمجها أو اربطها بالمعالم لاحقًا.",
      "TIME_AND_MATERIALS": "لا يُفوتر شيء من هذه البنود: يصبح المجموع الفرعي تقدير الإيرادات في موازنة مسودة.",
      "PROGRESS_CLAIMS": "المجموع الفرعي هو قيمة العقد، وجدول الكميات يأتي مع المستخلصات."
    },
    "lineAsItem": "فوترة «{{line}}» بندًا في الخطة",
    "itemsCount_zero": "لن يصبح أي من {{total}} بنود بند فوترة.",
    "itemsCount_one": "سيصبح بند واحد من {{total}} بند فوترة.",
    "itemsCount_two": "سيصبح بندان من {{total}} بندي فوترة.",
    "itemsCount_few": "ستصبح {{count}} من {{total}} بنود فوترة.",
    "itemsCount_many": "سيصبح {{count}} من {{total}} بند فوترة.",
    "itemsCount_other": "سيصبح {{count}} من {{total}} بند فوترة.",
    "errors": {
      "quotation": "اختر عرض سعر معتمدًا.",
      "billingMethod": "عرض السعر يُفوتر لعميله: اختر سعرًا ثابتًا أو وقتًا ومواد أو مستخلصات.",
      "expired": "انتهت صلاحية عرض السعر: أكّد أن العميل ما زال يقبله."
    },
    "save": "بدء المشروع",
    "created": "بدأ {{code}} من {{number}}"
  },
  "projectTax": {
    "rate": "ضريبة القيمة المضافة على الفوترة",
    "rateHint": "تُفوتر بنود خطة الفوترة والتكاليف المعاد فوترتها بهذه النسبة.",
    "companyRate": "النسبة الافتراضية للشركة",
    "pricesIncludeTax": "عُرض شاملًا الضريبة",
    "pricesIncludeTaxHint": "للعرض فقط: عُرضت الأسعار على العميل شاملة الضريبة. فواتير المشروع دائمًا دون الضريبة."
  },
  "reason": {
    "required": "اذكر السبب."
  },
  "errors": {
    "SALES_MODULE_OFF": "المبيعات معطلة لشركتك: تنتظر الفوترة حتى يفعّلها المسؤول.",
    "PROJECT_DOCUMENT": "أصدر مشروعٌ هذا المستند: أبطِله من تبويب الفوترة في المشروع.",
    "QUOTATION_STARTED_PROJECT": "بدأ عرض السعر هذا مشروعًا: فوتره من المشروع.",
    "PROJECT_NOT_BILLABLE": "لا يُفوتر هذا المشروع بهذه الطريقة (مشروع داخلي أو طريقة فوترة أخرى).",
    "PROJECT_FEATURE_OFF": "هذا النوع من الفوترة معطل لهذا المشروع (الإعدادات › المشاريع أو وظائف المشروع).",
    "PROJECT_NOT_OPEN": "المشروع مغلق أو ملغى: لا يمكن فوترته.",
    "IN_USE": "سبقت فوترته أو هو قيد الاستخدام: أبطِل فاتورته من المشروع أولًا.",
    "VERSION_CONFLICT": "غيّره شخص آخر في الأثناء. تظهر أحدث نسخة: راجعها وأعد المحاولة.",
    "CONFLICT": "غيّره شخص آخر في الأثناء (أُبطل أو فُوتر). تظهر القائمة حالته الآن.",
    "notReady": "لم يحن وقت فوترته بعد: لم يأتِ تاريخه أو معلمه أو تعليمه جاهزًا.",
    "writtenOff": "سطر مشطوب أو غير قابل للفوترة: حدد السطور القابلة للفوترة فقط.",
    "alreadyInvoiced": "سبقت فوترته: فوتره شخص آخر في الأثناء، وتظهر الخطة فاتورته.",
    "requestUsed": "سبق استخدام هذا الطلب لبنود أخرى. أغلق النافذة وابدأ من جديد."
  },
  "groupingHint": {
    "ROLE": "الوقت: سطر في الفاتورة لكل دور تسعير وسعر. التكاليف: سطر لكل فئة تكلفة.",
    "PERSON": "الوقت: سطر في الفاتورة لكل شخص وسعر. التكاليف: سطر لكل فئة تكلفة.",
    "ENTRY": "سطر في الفاتورة لكل سجل وقت (التاريخ والشخص والملاحظة) ولكل تكلفة."
  },
  "byClaims": {
    "title": "يُفوتر هذا العقد عبر المستخلصات",
    "body": "تصدر فواتيره من المستخلصات المعتمدة والدفعة المقدمة والإفراج عن المحتجزات، فلا تُفوتر خطة الفوترة ولا التكاليف من هنا.",
    "link": "فتح العقد › المستخلصات"
  }
}
